import React, { Component } from 'react'

import '../../css/BisharatMain.css';
import translate from '../../languages/translate';
import ActivityService from '../../services/ActivityService';

export default class Activity extends Component {
    state = {
        oneActivity: []
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        const activityId = params.id;
        ActivityService.getActivity(activityId)
            .then(res => {
                const oneActivity = res.data;
                this.setState({ oneActivity });
            })
    }


    

    render() {
        return (
            <div className="top-level-page-main member-detail">
                <div className="view-details member-detail ">
                    <div className="card-details">
                        <div className="card-group-field">
                            <h4> {translate("activity")}    </h4>
                            <h4> {this.state.oneActivity.activityName}   </h4>
                        </div>
                        <div className="card-group-field">
                            <h4>  {translate("activity-date")}     </h4>
                            <h4> {this.state.oneActivity.dateOfActivity}   </h4>
                        </div>

                        <div className="card-group-field">
                            <h4>  {translate("activity-link")}     </h4>
                            <h4> {this.state.oneActivity.activityLink}   </h4>
                        </div>

                        <a className="btn" href="/family-activities"> {translate("back")} </a>
                    </div>
                </div>
            </div>
        )
    }
}
